import { useNavigation } from 'modules/core/hooks/useNavigation'

import integrationCodes from 'modules/marketplace/lib/integrationCodes'

export const useCustomSettingsUrl = (datoId: string) => {
  const { navigation } = useNavigation()

  switch (datoId) {
    case integrationCodes.a3nom:
      return navigation.settings.compensations.integrationA3nom.fullPath()
    case integrationCodes.datev:
      return navigation.settings.compensations.integrationDatev.fullPath()
    case integrationCodes.datev_api:
    case integrationCodes.datev_lug_api:
      return navigation.settings.compensations.integrationDatevApi.fullPath()
    case integrationCodes.zucchetti:
      return navigation.settings.compensations.integrationZucchetti.fullPath()
    case integrationCodes.paierh:
      return navigation.settings.compensations.integrationPaierh.fullPath()
    case integrationCodes.yeap_paierh:
      return navigation.settings.compensations.integrationYeapPaierh.fullPath()
    case integrationCodes.silae:
      return navigation.settings.compensations.integrationSilae.fullPath()
    case integrationCodes.gispaghe:
      return navigation.settings.compensations.integrationGispaghe.fullPath()
    default:
      return undefined
  }
}
